import type { Distance } from "@pdfking/math"
import { RecordMerge } from "@pdfking/tfunc"

import type { FolderFlapOptions, FolderSide } from "#internal"
import type { GrowEdge } from "#public"

import { FolderFlap } from "./FolderFlap"

const swap = <T>([a, b]: [T, T]): [T, T] => [b, a]

/** A flap off `edge` of a die, its `options` read as the grow walks the
 * edge — a left or a right edge from its top, a top or a bottom one from its
 * left —, drawn as the die walks it, clockwise: a bottom or a left edge the
 * other way round, its pairs and its start and end sides swapped. What
 * hangs off its sides is drawn clockwise still. */
export const FolderFlapOff = (
  edge: GrowEdge,
  depth: Distance,
  options: Partial<FolderFlapOptions> = {}
): FolderSide => {
  if (edge === "top" || edge === "right") return FolderFlap(depth, options)
  const { taper, round, bevel, start, end, ...rest } = options
  return FolderFlap(
    depth,
    RecordMerge(
      rest,
      taper ? { taper: swap(taper) } : {},
      round ? { round: swap(round) } : {},
      bevel ? { bevel: swap(bevel) } : {},
      start ? { end: start } : {},
      end ? { start: end } : {}
    )
  )
}
